import React from "react";
import { useHistory } from "react-router-dom";
import ContactForm from "./ContactForm";

const ContactTwo = () => {
  const history = useHistory();

  return (
    <div className="contact-form--1">
      <div className="container">
        <div className="row row--35 align-items-start">
          <div
            className="col-lg-12 order-1 order-lg-2"
            style={{
              display: `flex`,
              justifyContent: `center`,
              alignItems: `center`,
            }}
          >
            <div className="section-title text-left mb--50">
              <h3 className="title mb-5" style={{ lineHeight: "normal" }}>
                XRAI에 궁금하신 것이 있다면 얼마든지 문의해주세요.
              </h3>
              <ul className="checklist">
                <h4 className="myh3 mb-5">
                  <li>문의하시고 싶은 내용을 최대한 자세히 작성해주세요!</li>
                </h4>
                <h4 className="myh3 mb-5">
                  <li>
                    평균적으로 영업일 기준 3일 이내에 연락드리도록 하겠습니다.
                  </li>
                </h4>
                <h4 className="myh3 mb-5">
                  <li>모든 문의는 무료입니다.</li>
                </h4>
              </ul>
              <div className="rn-form-group">
                <button
                  onClick={() => history.push("/border")}
                  className="rn-button-style--2 btn-solid"
                >
                  문의하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactTwo;
